<template>
  <div
    id="modalRfb"
    class="modal fade"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="modalRfbMessage"
  >
    <div class="modal-dialog text-start">
      <div class="modal-content">
        <div class="modal-header">
          <h1 id="modalRfbMessage" class="modal-title fs-5">
            Informações sobre a empresa
          </h1>
          <button
            class="btn-close"
            type="button"
            data-bs-dismiss="modal"
            aria-label="Fechar"
          ></button>
        </div>
        <div class="modal-body py-4">
          <p class="fs-6">Legal! Seu novo Certificado será para sua empresa!</p>
          <p class="fs-6">
            Para qual CNPJ você deseja emitir este Certificado?
          </p>
          <Input
            v-model="model.cnpj"
            label="CNPJ"
            icon="building"
            placeholder="Digite apenas números"
            is-numeric
            :mask="['**.***.***/****-##', '']"
            :error-log="error"
          />
        </div>

        <div class="modal-footer border-top-1">
          <button
            class="btn modal-footer_btn-process btn-primary"
            type="button"
            @click="handleNextStep"
          >
            <span class="me-2">Avançar</span>
            <Icon name="arrow-right" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from 'vue'
  import { Modal } from 'bootstrap'
  import Input from '../Atoms/Input.vue'
  import Icon from '../Atoms/Icon.vue'
  import { VoucherParam } from '@/infra/BirdId/controllers/login.controller'
  import { mapActions } from 'pinia'
  import { useDynamicForms } from '@/store/Pinia/useDynamicForms.store'
  import { useModalLoading } from '@/store/Pinia/useModalLoading.store'

  export default defineComponent({
    name: 'ModalRFB',
    components: {
      Input,
      Icon,
    },
    props: {
      createSolicitation: {
        type: Function,
        required: true,
      },
      request: {
        type: Object as PropType<VoucherParam>,
      },
    },
    data: () => ({
      model: {
        cnpj: '',
      },
      modal: null as any,
      error: '',
    }),
    methods: {
      ...mapActions(useDynamicForms, ['setCNPJ']),
      ...mapActions(useModalLoading, ['setIsLoading']),
      modalOpen() {
        this.modal.show()
      },
      modalClose() {
        const activeElement = document.activeElement as HTMLElement
        if (activeElement) {
          activeElement.blur()
        }
        this.modal.hide()
      },
      async handleNextStep() {
        if (this.model.cnpj === '') {
          this.error = 'CNPJ é obrigatório.'
          return
        }

        setTimeout(() => {
          this.setIsLoading({
            isLoading: true,
            title: 'Aguarde enquanto localizamos seu Voucher/Pedido',
            image: 'zoom',
            message: '',
          })
        }, 100)

        const model = { ...this.request, cnpj: this.model.cnpj }

        await this.$props.createSolicitation(model)

        this.setCNPJ(this.model.cnpj)

        this.modalClose()
      },
    },
    mounted() {
      const modal = document.getElementById('modalRfb') as HTMLElement
      this.modal = new Modal(modal, {})
    },
  })
</script>

<style lang="stylus" scoped>

  .img-wait
    max-width: 190px
    max-height 190px
  .img-zoom
    max-width: 190px
    max-height 190px

  .btn-modal
    opacity: 0

  #modalRfb
    .modal-dialog
      max-width: 400px

  @media screen and (max-width: 576px)
    .modal-dialog
      height: auto
      margin: 0.5rem
    .modal-content
      border-radius: 0.5rem
</style>
